import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useToast } from 'hooks/ui';
import { rejectTask } from 'api/task.service';

export const useTaskReopenQuery = () => {
  const toast = useToast();
  const queryClient = useQueryClient();

  const { isLoading, mutate } = useMutation(
    ({ id }: { id: string }) => rejectTask(id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['tasks']);
        toast.success('Task reopened successfully');
      },
      onError: (error: AxiosError) => {
        toast.error(error.message);
      },
    },
  );

  return { isLoading, mutate };
};
